import setPropertyReducers from "./setPropertyReducers";

const tabValueReducers = (prefixes: string[]) =>
  setPropertyReducers(prefixes.map((prefix) => `${prefix}TabValue`));

export default tabValueReducers;
